// The closed vocabularies of /news (#3931, founder pick A of the 2026-10-11
// mocks): every story carries ONE `topic` from NEWS_TOPICS, and its story
// type comes from its `eventLabel` through STORY_TYPE_BY_LABEL. Both lists are
// closed on purpose: __tests__/newsFind.test.js fails on a story whose topic or label
// is not here, so a new value is a decision made in this file, never a chip
// that quietly appears (or a row that quietly loses its type).
//
// The News desk writes `topic` at publish time from the lead's kind
// (KIND_WEIGHT in scripts/desk/news_leads.py). Keep the ids in step with it.

// Chip order is the order below. `guide` is the evergreen /resources paper a
// no-results search on this topic points to; `words` are the phrases a typed
// search uses to find that guide when nothing on /news matches.
export const NEWS_TOPICS = [
    { id: 'cost_aid', label: 'Cost & aid', guide: 'what-college-actually-costs',
      words: ['cost', 'price', 'tuition', 'aid', 'afford', 'net price', 'scholarship', 'loan', 'grant', 'free'] },
    { id: 'testing', label: 'Testing', guide: 'should-you-submit-test-scores',
      words: ['test', 'sat', 'act', 'score', 'test optional', 'test-optional', 'test blind'] },
    { id: 'programs', label: 'Programs', guide: 'building-your-application-strategy',
      words: ['program', 'direct admission', 'direct admissions', 'academy', 'co-op'] },
    { id: 'deadlines_rounds', label: 'Deadlines & rounds', guide: 'does-early-decision-improve-your-chances',
      words: ['deadline', 'early decision', 'early action', 'ed', 'ea', 'rea', 'round', 'apply', 'application', 'common app'] },
    { id: 'admissions_records', label: 'Admissions records', guide: 'reading-your-odds',
      words: ['record', 'acceptance rate', 'admit rate', 'odds', 'applications', 'admitted', 'chances'] },
    { id: 'fafsa_federal_aid', label: 'FAFSA & federal aid', guide: 'what-college-actually-costs',
      words: ['fafsa', 'federal aid', 'css profile', 'pell', 'student aid', 'efc', 'sai'] },
    { id: 'other', label: 'Other', guide: null, words: [] },
];

export const NEWS_TOPIC_IDS = NEWS_TOPICS.map((t) => t.id);
export const topicById = (id) => NEWS_TOPICS.find((t) => t.id === id) || null;

// The story type a row shows, from the story's own eventLabel. A label not in
// this map has no type: the test fails rather than the row guessing one.
export const STORY_TYPE_BY_LABEL = {
    'Announced': 'announcement',
    'Announcement dated': 'announcement',
    'Preview published': 'announcement',
    'Report released': 'data_release',
    'Data released': 'data_release',
    'Opened': 'now_open',
    'Opened to everyone': 'now_open',
    'Proposed': 'proposed',
};

export const STORY_TYPE_LABELS = {
    announcement: 'Announcement',
    data_release: 'Data release',
    now_open: 'Now open',
    proposed: 'Proposed',
};

export const storyType = (story) => STORY_TYPE_BY_LABEL[story?.eventLabel] || null;
